export default __webpack_public_path__ + "static/media/icon_description_write_white.cb36adc2.svg";